const requireApi = require.context('./modules', false, /.js$/)
const modules = requireApi.keys().reduce((prev, item) => {
  const moduleName = item.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = requireApi(item)
  prev[moduleName] = value
  return prev
}, {})

export default modules
